import _ from "lodash";
import {
    ADD_EMPLOYEE,
    FETCH_EMPLOYEES,
    EDIT_EMPLOYEE,
    DELETE_EMPLOYEE,
    FETCH_PREMISES_LIST,
    ADD_PREMISES,
    EDIT_PREMISES,
    DELETE_PREMISES,
    ADD_CONSULTANT,
    FETCH_CONSULTANTS,
    EDIT_CONSULTANT,
    DELETE_CONSULTANT,
    FETCH_PURCHASES,
    ADD_PURCHASE,
    EDIT_PURCHASE,
    DELETE_PURCHASE,
    FETCH_LEASINGS,
    ADD_LEASING,
    EDIT_LEASING,
    DELETE_LEASING,
    FETCH_RENTALS,
    ADD_RENTAL,
    EDIT_RENTAL,
    DELETE_RENTAL,
    ADD_MATERIAL,
    EDIT_MATERIAL,
    DELETE_MATERIAL,
    FETCH_MATERIALS,
    ADD_PRODUCTION_VOLUME,
    EDIT_PRODUCTION_VOLUME,
    DELETE_PRODUCTION_VOLUME,
    FETCH_PRODUCTION_VOLUMES,
    ADD_LOAN,
    EDIT_LOAN,
    DELETE_LOAN,
    FETCH_LOANS,
    ADD_DIGITAL_AD,
    EDIT_DIGITAL_AD,
    DELETE_DIGITAL_AD,
    FETCH_DIGITAL_ADS,
    ADD_EVENT,
    EDIT_EVENT,
    DELETE_EVENT,
    FETCH_EVENTS,
    ADD_MARKET_RESEARCH,
    EDIT_MARKET_RESEARCH,
    DELETE_MARKET_RESEARCH,
    FETCH_MARKET_RESEARCH,
    ADD_BRANDING_PROJECT,
    EDIT_BRANDING_PROJECT,
    DELETE_BRANDING_PROJECT,
    FETCH_BRANDING_PROJECTS,
    ADD_SERVICE,
    EDIT_SERVICE,
    DELETE_SERVICE,
    FETCH_SERVICES
} from '../actions/types';

const INITIAL_STATE = {
    employeeCosts: {},
    consultantCosts: {},
    premisesCosts: {},
    purchaseCosts: {},
    leasingCosts: {},
    rentalCosts: {},
    materialCosts: {},
    productionVolumes: {},
    loanCosts: {},
    digitalAdCosts: {},
    eventCosts: {},
    marketResearchCosts: {},
    brandingCosts: {},
    serviceCosts: {},
};

const costReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_EMPLOYEES:
            return { ...state, employeeCosts: { ...state.employeeCosts, ..._.mapKeys(action.payload.employee_costs, 'id') } };
        case ADD_EMPLOYEE:
            return { ...state, employeeCosts: { ...state.employeeCosts, [action.payload.employee_costs.id]: action.payload.employee_costs } };
        case EDIT_EMPLOYEE:
            return { ...state, employeeCosts: { ...state.employeeCosts, [action.payload.employee_costs.id]: action.payload.employee_costs } };
        case DELETE_EMPLOYEE:
            return { ...state, employeeCosts: _.omit(state.employeeCosts, action.payload.id) };

        case FETCH_CONSULTANTS:
            return { ...state, consultantCosts: { ...state.consultantCosts, ..._.mapKeys(action.payload.consultant_costs, 'id') } };
        case ADD_CONSULTANT:
            return { ...state, consultantCosts: { ...state.consultantCosts, [action.payload.consultant_costs.id]: action.payload.consultant_costs } };
        case EDIT_CONSULTANT:
            return { ...state, consultantCosts: { ...state.consultantCosts, [action.payload.consultant_costs.id]: action.payload.consultant_costs } };
        case DELETE_CONSULTANT:
            return { ...state, consultantCosts: _.omit(state.consultantCosts, action.payload.id) };

        case FETCH_PREMISES_LIST:
            return { ...state, premisesCosts: { ...state.premisesCosts, ..._.mapKeys(action.payload.premises_costs, 'id') } };
        case ADD_PREMISES:
            return { ...state, premisesCosts: { ...state.premisesCosts, [action.payload.premises_costs.id]: action.payload.premises_costs } };
        case EDIT_PREMISES:
            return { ...state, premisesCosts: { ...state.premisesCosts, [action.payload.premises_costs.id]: action.payload.premises_costs } };
        case DELETE_PREMISES:
            return { ...state, premisesCosts: _.omit(state.premisesCosts, action.payload.id) };

        case FETCH_PURCHASES:
            return { ...state, purchaseCosts: { ...state.purchaseCosts, ..._.mapKeys(action.payload.purchase_costs, 'id') } };
        case ADD_PURCHASE:
            return { ...state, purchaseCosts: { ...state.purchaseCosts, [action.payload.purchase_costs.id]: action.payload.purchase_costs } };
        case EDIT_PURCHASE:
            return { ...state, purchaseCosts: { ...state.purchaseCosts, [action.payload.purchase_costs.id]: action.payload.purchase_costs } };
        case DELETE_PURCHASE:
            return { ...state, purchaseCosts: _.omit(state.purchaseCosts, action.payload.id) };

        case FETCH_LEASINGS:
            return { ...state, leasingCosts: { ...state.leasingCosts, ..._.mapKeys(action.payload.leasing_costs, 'id') } };
        case ADD_LEASING:
            return { ...state, leasingCosts: { ...state.leasingCosts, [action.payload.leasing_costs.id]: action.payload.leasing_costs } };
        case EDIT_LEASING:
            return { ...state, leasingCosts: { ...state.leasingCosts, [action.payload.leasing_costs.id]: action.payload.leasing_costs } };
        case DELETE_LEASING:
            return { ...state, leasingCosts: _.omit(state.leasingCosts, action.payload.id) };

        case FETCH_RENTALS:
            return { ...state, rentalCosts: { ...state.rentalCosts, ..._.mapKeys(action.payload.rental_costs, 'id') } };
        case ADD_RENTAL:
            return { ...state, rentalCosts: { ...state.rentalCosts, [action.payload.rental_costs.id]: action.payload.rental_costs } };
        case EDIT_RENTAL:
            return { ...state, rentalCosts: { ...state.rentalCosts, [action.payload.rental_costs.id]: action.payload.rental_costs } };
        case DELETE_RENTAL:
            return { ...state, rentalCosts: _.omit(state.rentalCosts, action.payload.id) };

        case FETCH_MATERIALS:
            return { ...state, materialCosts: { ...state.materialCosts, ..._.mapKeys(action.payload.material_costs, 'id') } };
        case ADD_MATERIAL:
            return { ...state, materialCosts: { ...state.materialCosts, [action.payload.material_costs.id]: action.payload.material_costs } };
        case EDIT_MATERIAL:
            return { ...state, materialCosts: { ...state.materialCosts, [action.payload.material_costs.id]: action.payload.material_costs } };
        case DELETE_MATERIAL:
            return { ...state, materialCosts: _.omit(state.materialCosts, action.payload.id) };

        case FETCH_PRODUCTION_VOLUMES:
            return { ...state, productionVolumes: { ...state.productionVolumes, ..._.mapKeys(action.payload.production_volumes, 'id') } };
        case ADD_PRODUCTION_VOLUME:
            return { ...state, productionVolumes: { ...state.productionVolumes, [action.payload.production_volumes.id]: action.payload.production_volumes } };
        case EDIT_PRODUCTION_VOLUME:
            return { ...state, productionVolumes: { ...state.productionVolumes, [action.payload.production_volumes.id]: action.payload.production_volumes } };
        case DELETE_PRODUCTION_VOLUME:
            return { ...state, productionVolumes: _.omit(state.productionVolumes, action.payload.id) };

        case FETCH_LOANS:
            return { ...state, loanCosts: { ...state.loanCosts, ..._.mapKeys(action.payload.loan_costs, 'id') } };
        case ADD_LOAN:
            return { ...state, loanCosts: { ...state.loanCosts, [action.payload.loan_costs.id]: action.payload.loan_costs } };
        case EDIT_LOAN:
            return { ...state, loanCosts: { ...state.loanCosts, [action.payload.loan_costs.id]: action.payload.loan_costs } };
        case DELETE_LOAN:
            return { ...state, loanCosts: _.omit(state.loanCosts, action.payload.id) };

        case FETCH_DIGITAL_ADS:
            return { ...state, digitalAdCosts: { ...state.digitalAdCosts, ..._.mapKeys(action.payload.digital_ad_costs, 'id') } };
        case ADD_DIGITAL_AD:
            return { ...state, digitalAdCosts: { ...state.digitalAdCosts, [action.payload.digital_ad_costs.id]: action.payload.digital_ad_costs } };
        case EDIT_DIGITAL_AD:
            return { ...state, digitalAdCosts: { ...state.digitalAdCosts, [action.payload.digital_ad_costs.id]: action.payload.digital_ad_costs } };
        case DELETE_DIGITAL_AD:
            return { ...state, digitalAdCosts: _.omit(state.digitalAdCosts, action.payload.id) };

        case FETCH_EVENTS:
            return { ...state, eventCosts: { ...state.eventCosts, ..._.mapKeys(action.payload.event_costs, 'id') } };
        case ADD_EVENT:
            return { ...state, eventCosts: { ...state.eventCosts, [action.payload.event_costs.id]: action.payload.event_costs } };
        case EDIT_EVENT:
            return { ...state, eventCosts: { ...state.eventCosts, [action.payload.event_costs.id]: action.payload.event_costs } };
        case DELETE_EVENT:
            return { ...state, eventCosts: _.omit(state.eventCosts, action.payload.id) };

        case FETCH_MARKET_RESEARCH:
            return { ...state, marketResearchCosts: { ...state.marketResearchCosts, ..._.mapKeys(action.payload.market_research_costs, 'id') } };
        case ADD_MARKET_RESEARCH:
            return { ...state, marketResearchCosts: { ...state.marketResearchCosts, [action.payload.market_research_costs.id]: action.payload.market_research_costs } };
        case EDIT_MARKET_RESEARCH:
            return { ...state, marketResearchCosts: { ...state.marketResearchCosts, [action.payload.market_research_costs.id]: action.payload.market_research_costs } };
        case DELETE_MARKET_RESEARCH:
            return { ...state, marketResearchCosts: _.omit(state.marketResearchCosts, action.payload.id) };

        case FETCH_BRANDING_PROJECTS:
            return { ...state, brandingCosts: { ...state.brandingCosts, ..._.mapKeys(action.payload.branding_costs, 'id') } };
        case ADD_BRANDING_PROJECT:
            return { ...state, brandingCosts: { ...state.brandingCosts, [action.payload.branding_costs.id]: action.payload.branding_costs } };
        case EDIT_BRANDING_PROJECT:
            return { ...state, brandingCosts: { ...state.brandingCosts, [action.payload.branding_costs.id]: action.payload.branding_costs } };
        case DELETE_BRANDING_PROJECT:
            return { ...state, brandingCosts: _.omit(state.brandingCosts, action.payload.id) };

        case FETCH_SERVICES:
            return { ...state, serviceCosts: { ...state.serviceCosts, ..._.mapKeys(action.payload.service_costs, 'id') } };
        case ADD_SERVICE:
            return { ...state, serviceCosts: { ...state.serviceCosts, [action.payload.service_costs.id]: action.payload.service_costs } };
        case EDIT_SERVICE:
            return { ...state, serviceCosts: { ...state.serviceCosts, [action.payload.service_costs.id]: action.payload.service_costs } };
        case DELETE_SERVICE:
            return { ...state, serviceCosts: _.omit(state.serviceCosts, action.payload.id) };

        default:
            return state;
    }
};

export default costReducer